import { Radio, Space, Card } from 'antd';
import React from 'react';

const mockValues = ['Metis', 'Adrastea'];
const options = mockValues.map((value) => {
  return {
    value: value.toLowerCase(),
    label: value,
    disabled: false,
  }
});
const indexToDisable = Math.floor(Math.random() * mockValues.length);
options[indexToDisable].disabled = true;

function Radios() {
  return (
    <Card title="Radio">
      <Space>
        <Radio.Group defaultValue="a" buttonStyle="solid">
          <Radio.Button value="a">Metis</Radio.Button>
          <Radio.Button value="b" disabled>Adrastea</Radio.Button>
          <Radio.Button value="c">Amalthea</Radio.Button>
        </Radio.Group>

        <Radio.Group defaultValue="a">
          <Radio.Button value="a">Metis</Radio.Button>
          <Radio.Button value="b" disabled>Adrastea</Radio.Button>
          <Radio.Button value="c">Amalthea</Radio.Button>
        </Radio.Group>

        <Radio.Group options={options} defaultValue="Metis" />
      </Space>
    </Card>
  )
}


export default Radios;
